export enum Durations {
  FIFTEEN_MINUTES_IN_SECONDS = 900,
  FIVE_MINUTES_IN_SECONDS = 300,
  ONE_DAY_IN_MILLISECONDS = 86400000,
  ONE_DAY_IN_SECONDS = 86400,
  ONE_HOUR_IN_MILLISECONDS = 3600000,
  ONE_HOUR_IN_SECONDS = 3600,
  ONE_MINUTE_IN_MILLISECONDS = 60000,
  ONE_MINUTE_IN_SECONDS = 60,
  ONE_SECOND_IN_MILLISECONDS = 1000,
  ONE_WEEK_IN_SECONDS = 604800,
  TEN_MINUTES_IN_SECONDS = 600,
  ONE_YEAR_IN_SECONDS = 31536000,
  TEN_YEARS_IN_SECONDS = 315360000,
  TWO_MINUTES_IN_SECONDS = 120,
}
